import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

export const getTargetDep6 = (id, type) => {
  const url = `${API_ROOT}/proposal/${id}/target/dep6/${type}`
  return doGet(url)
}

export const saveTargetDep6 = (id, type, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/dep6/${type}`
  return doPost(url, request)
}

export const updateTargetDep6 = (id, type, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/dep6/${type}/${request.id}`
  return doPut(url, request)
}

export const deleteTargetDep6 = (id, targetId) => {
  const url = `${API_ROOT}/proposal/${id}/target/dep6/${targetId}`
  return doDelete(url)
}

export const saveTargetDep6Criteria = (id, type, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/dep6/criteria/${type}`
  return doPost(url, request)
}

export const updateTargetDep6Criteria = (id, type, request) => {
  const url = `${API_ROOT}/proposal/${id}/target/dep6/criteria/${type}`
  return doPut(url, request)
}
